import type { SparklinePoint } from './MentionsSparkline';

interface Datable { date?: string | null }

/** Bucket documents by year-month and emit a contiguous monthly series. */
export function sparklineFromDocs(docs: Datable[]): SparklinePoint[] {
  const counts = new Map<string, number>();
  let minYM: string | null = null;
  let maxYM: string | null = null;

  for (const d of docs) {
    const m = d.date && /^(\d{4})-(\d{2})/.exec(d.date);
    if (!m) continue;
    const ym = `${m[1]}-${m[2]}`;
    counts.set(ym, (counts.get(ym) || 0) + 1);
    if (minYM === null || ym < minYM) minYM = ym;
    if (maxYM === null || ym > maxYM) maxYM = ym;
  }

  if (!minYM || !maxYM) return [];

  const out: SparklinePoint[] = [];
  let [y, mo] = minYM.split('-').map(Number);
  const [endY, endMo] = maxYM.split('-').map(Number);
  while (y < endY || (y === endY && mo <= endMo)) {
    const ym = `${y}-${String(mo).padStart(2, '0')}`;
    out.push({ ym, n: counts.get(ym) || 0 });
    mo += 1;
    if (mo > 12) { mo = 1; y += 1; }
  }
  return out;
}
